exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-content[data-v-0d1db60a] {\n  margin-top: 3em;\n}\n.button[data-v-0d1db60a] {\n  font-weight: 700;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/billing/PageBillingMain.vue"],"names":[],"mappings":";AAgEA;EACE,gBAAe;CAChB;AAED;EACE,iBAAgB;CACjB","file":"PageBillingMain.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.page-content {\n  margin-top: 3em;\n}\n\n.button {\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d1db60a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/PageBillingMain.vue
// module id = ShvA
// module chunks = 72